module.exports = __webpack_public_path__ + "img/01.75d97867.png";